module.exports = __webpack_public_path__ + "img/card2.8d90e83a.png";